import { render, staticRenderFns } from "./printerIcon.vue?vue&type=template&id=2b7fd481"
import script from "./printerIcon.vue?vue&type=script&lang=js"
export * from "./printerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports